import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { IconGeneric } from '@spotahome/ui-library';
import classNames from 'classnames';

import CheckBox from '../../../LEGACY/javascripts/ui/form/form-checkbox';

import './CityAreaFilter.scss';

const MAX_OF_AREAS_TO_SHOW = 8;
const INITIAL_HEIGHT = '0px';

const ShowMoreButton = ({ className, onClick, isDropDownActive }) => {
  const showMoreIconName = isDropDownActive ? 'angle-top' : 'angle-down';
  const showMoreLabelTrans = isDropDownActive
    ? 'search.filter.area.show_less'
    : 'search.filter.area.show_more';

  return (
    <div className={className}>
      <button className="show-more-button" onClick={onClick}>
        {trans(showMoreLabelTrans)}
        <IconGeneric name={showMoreIconName} color="green" />
      </button>
    </div>
  );
};

class CityAreaFilter extends Component {
  static propTypes = {
    cityAreaIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    cityAreas: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    ).isRequired,
    onChange: PropTypes.func.isRequired,
    prefix: PropTypes.string.isRequired
  };

  state = {
    isDropDownActive: false
  };

  setNeighborhood = areaId => checked => {
    let { cityAreaIds } = this.props;

    const stringAreaId = `${areaId}`;

    if (checked) {
      cityAreaIds = [...cityAreaIds, stringAreaId];
    } else {
      cityAreaIds = cityAreaIds.filter(id => id !== stringAreaId);
    }

    this.props.onChange(cityAreaIds);
  };

  filterWrapperBodyref = React.createRef();

  calculateMaxHeight = () => {
    const contentStyles = this.filterWrapperBodyref.current;

    if (typeof window !== 'undefined') {
      window.getComputedStyle(contentStyles).height;
    }
  };

  handleShowMore = () => {
    this.setState(prevState => ({
      isDropDownActive: !prevState.isDropDownActive
    }));
  };
  hasMoreAreasToShow = () => this.props.cityAreas.length > MAX_OF_AREAS_TO_SHOW;

  render() {
    const { cityAreas, cityAreaIds, prefix, isAlert } = this.props;
    const { isDropDownActive } = this.state;

    const height = isDropDownActive
      ? this.calculateMaxHeight()
      : INITIAL_HEIGHT;

    const clearfixClassName = classNames('clearfix', {
      'clearfix--with-neighborhoods-alert': isAlert,
      'clearfix--with-neighborhoods-filters': !isAlert
    });

    return (
      <div className="wrapper-area-filters">
        <div className="area-filters">
          {cityAreas.slice(0, MAX_OF_AREAS_TO_SHOW).map(area => {
            const identifier = `${prefix}_${area.id}`;
            const label = `area.id_${area.id}`;
            const checked = cityAreaIds.includes(`${area.id}`);

            return (
              <CheckBox
                id={identifier}
                key={identifier}
                label={trans(label)}
                tracking={`ga-search-form-area-${area.id}`}
                checked={checked}
                onChange={this.setNeighborhood(area.id)}
              />
            );
          })}
        </div>
        {this.hasMoreAreasToShow() && (
          <Fragment>
            <div
              className={
                isDropDownActive
                  ? 'area area-filters-show-more'
                  : 'area area-filters'
              }
              style={{ height }}
            >
              <div
                ref={this.filterWrapperBodyref}
                className={clearfixClassName}
              >
                {cityAreas.slice(MAX_OF_AREAS_TO_SHOW).map(area => {
                  const identifier = `${prefix}_${area.id}`;
                  const label = `area.id_${area.id}`;
                  const checked = cityAreaIds.includes(`${area.id}`);

                  return (
                    <CheckBox
                      id={identifier}
                      key={identifier}
                      label={trans(label)}
                      tracking={`ga-search-form-area-${area.id}`}
                      checked={checked}
                      onChange={this.setNeighborhood(area.id)}
                    />
                  );
                })}
              </div>
            </div>
            <ShowMoreButton
              className="wrapper-show-more-button"
              data-cy="ShowMoreButton"
              onClick={this.handleShowMore}
              isDropDownActive={isDropDownActive}
            />
          </Fragment>
        )}
      </div>
    );
  }
}

export default CityAreaFilter;
